/* eslint-disable react/prop-types */
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { safeJsonParse } from '@rcw/utils';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState(safeJsonParse(localStorage.getItem('cart'), []));

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]); // only run when cart changes

  const addToCart = useCallback((product) => {
    setCart((prevCart) => {
      const alreadyInCart = prevCart.some((p) => p.id === product.id);
      if (alreadyInCart) return prevCart;

      const hasDiscount = Boolean(
        product?.promoLabel || product?.discountValue || product?.discountPrice || product?.discountPercentage,
      );

      const item = {
        id: product.id,
        title: product.title,
        thumbnail: product.squareThumbnail || product.imageUrl,
        price: product?.discountPrice || product?.price || product?.Price,
        category: product.MenuSection || product.category,
        primary: product?.primary,
        subCategory1: product?.subCategory1,
        IsPromo: (product?.isPromo ?? product?.IsPromo ?? false) && hasDiscount,
        promoLabel: product?.promoLabel,
        originalPrice: product?.nonPromoPrice || product?.Price || product?.price,
        discountPrice: product?.discountPrice,
        discountType: product?.discountType,
        discountValue: product?.discountValue,
        discountPercentage: product?.discountPercentage,
      };

      return [...prevCart, item];
    });
  }, []);

  const removeFromCart = useCallback((id) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== id));
  }, []);

  const clearCart = useCallback(() => {
    setCart([]);
    localStorage.removeItem('cart');
  }, []);

  const contextValue = useMemo(() => ({
    cart,
    addToCart,
    removeFromCart,
    clearCart,
  }), [cart, addToCart, removeFromCart, clearCart]);

  return (
    <CartContext.Provider value={contextValue}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
